import { createSlice } from '@reduxjs/toolkit'
import { request } from '@utils/request'

export interface BlogState {

}

const initialState: BlogState = {

}

export const BlogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {}
})

const API_NAME = '/blog'
// 博客列表
export const getBlogList = (params: any): any => {
  return request.get(`${API_NAME}/display`, params).then((res) => {
    return res.data
  })
}

// // 博客详情
// export const getBlogDetail = (params: any): any => {
//   return request.get(`${API_NAME}/detail`, params).then((res) => {
//     return res.data
//   })
// }

export const {  } = BlogSlice.actions

export default BlogSlice.reducer
